<template>
    <small v-if="!useUserStore().user.is_corporate">
        {{ $t('Premium') }}:
        {{ $formatter.price(product.premium_value <= 0 ? 0 : product.premium_value) }}
        ({{ $formatter.percent(product.premium_percent <= 0 ? 0 : product.premium_percent) }}%)
    </small>
</template>

<script setup>
const props = defineProps({
    product: Object,
    class: String
});
</script>
